var heading_default = {
  "fontElementMap": "I9zhA",
  "elementSpacing": "Ys7t4",
  "headerOne": "rvaf- Ys7t4",
  "headerTwo": "VNVtA Ys7t4",
  "headerThree": "JMVyN Ys7t4",
  "headerFour": "YIBV0 Ys7t4",
  "headerFive": "c1665 Ys7t4",
  "headerSix": "_6T0jC Ys7t4",
  "child": "u6seX"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
